// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"52843fd7","179":"24dcfde3","241":"16565c22","446":"32b16882","460":"84362f36","488":"22b449f6","597":"cd5ade36","728":"6f08818f","730":"1201ed67","829":"8afa9bd3","969":"64261927","979":"61e4714d"}[chunkId] + ".chunk.js";
};